import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font, Image
} from "@react-pdf/renderer";

import fontDev from './THSarabun.ttf';
import moment from "moment/min/moment-with-locales";
import base64Logo from '../page/admin/logoBase64';
import LogoPD from '../page/employee/LogoPD';

// Register font
Font.register({ family: 'THSarabun', src: fontDev });

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    fontFamily: 'Healthy',
    padding: 30,
  },
  subTitle: {
    fontSize: 12,
    marginBottom: 5,
  },
  addressContainer: {
    marginBottom: 5,
  },
  addressSubTitle: {
    fontSize: 10,
    marginBottom: 5,
    lineHeight: 1.2,
  },
  addressTitle: {
    fontSize: 14, // ขนาดตัวอักษรเล็กลง
    fontWeight: 'bold',
    marginBottom: 3,
  },
  addressText: {
    fontSize: 12, // ลดขนาดตัวอักษรให้เล็กลง
    marginBottom: 2,
  },
  bold: {
    fontSize: 14
  },
  section: {
    marginTop: 20,
    fontSize: 12,
    textAlign: 'center', // Center align the text in the section
  },

  logo: {
    width: 100,
    height: 100,
    marginBottom: 10,
  },
  image: {
    width: 100,
    height: 100,
    marginBottom: 10,
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  titleContainer: {
    flex: 1,
    marginLeft: 20, // Adjust this margin to control the space between image and text
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 5,
  },

  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "33.33%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
  },
  summary: {
    textAlign: 'right'
  },

  //รายเชน
  signatureContainer: {
    marginTop: 40,
    flexDirection: 'row',
    justifyContent: 'space-between', // Change this to flex-end to align items to the right
  },
  signatureBox: {
    width: '30%',
    borderWidth: 1,
    borderColor: "#FFFFFF",
    padding: 10,
    minHeight: 100,
    textAlign: 'center',
    alignSelf: 'flex-end', // Add this line to align the box to the right
  },
  signatureText: {
    fontSize: 12,
    marginBottom: 20,
  },
  signatureLine: {
    marginTop: 20,
    borderTopWidth: 1,
    borderColor: "#000",
    width: '60%',
    alignSelf: 'center',
  },
  receiverText: {
    fontSize: 12,
    marginTop: 15,
  },

  bottomRightContainer: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    alignItems: 'flex-end',
  },
  bottomRightLogo: {
    width: 60,
    height: 60,
    marginBottom: 5,
  },
  bottomRightText: {
    fontSize: 10,
    textAlign: 'right',
  },
});

const numberToThaiText = (number) => {
  const thaiNumbers = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
  const thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];
  let text = "";

  const baht = Math.floor(number); // ส่วนจำนวนเต็ม
  const satang = Math.round((number - baht) * 100); // ส่วนทศนิยม (สตางค์)

  const convert = (num) => {
    let result = "";
    const numStr = num.toString();
    const len = numStr.length;

    for (let i = 0; i < len; i++) {
      const digit = parseInt(numStr[i]);
      const unitIndex = len - i - 1;

      if (digit !== 0) {
        if (unitIndex === 1 && digit === 1) {
          result += "สิบ";
        } else if (unitIndex === 1 && digit === 2) {
          result += "ยี่สิบ";
        } else if (unitIndex === 0 && digit === 1 && len > 1) {
          result += "เอ็ด";
        } else {
          result += thaiNumbers[digit] + thaiUnits[unitIndex];
        }
      }
    }
    return result;
  };

  if (baht > 0) {
    text += convert(baht) + "บาท";
  }
  if (satang > 0) {
    text += convert(satang) + "สตางค์";
  } else {
    text += "ถ้วน";
  }

  return text;
};

const sanitizedText = (text) => {
  return typeof text === 'string' ? text.replace(/<[^>]+>/g, '') : '';
};
const Invoice = ({ order }) => {
  // ใช้ optional chaining + default object
  const {
    name = "ไม่ระบุ",
    phone = "ไม่ระบุ",
    email = order?.orderdBy?.email || "ไม่ระบุ",
    address = "ไม่ระบุ",
  } = order?.orderdBy?.address || {};

  const totalBeforeDiscount = order.products.reduce((sum, item) => {
    return sum + (item.price * item.count); // ถ้ามีจำนวนสินค้า
  }, 0);

  const vat = totalBeforeDiscount * 0.07;
  // คำนวณส่วนลดจากคูปอง
  const couponAmount = (totalBeforeDiscount * order.couponDiscount) / 100;
  const totalNotVat = totalBeforeDiscount - vat;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Image
            style={styles.image}
            src={LogoPD}
          />
          <View style={styles.titleContainer}>
            <Text style={styles.title}>บริษัท พีดี มาร์เก็ตติ้ง อินโนเวท จำกัด{"\n"}
              PD MARKETING INNOVATE CO.,LTD
            </Text>
            {/* <Text style={styles.title}>ภายใต้บริษัท PD MARKETING INNOVATE CO.,LTD</Text> */}
            <Text style={styles.addressSubTitle}>
              50/228 หมู่บ้านมัณฑนา พระรามเก้าศรีนครินทร์{"\n"}
              ซอยหรุงเทพกรีฑา7 แขวงหัวหมาก เขตบางกะปิ กรุงเทพฯ 10240{"\n"}
              เลขประจำตัวผู้เสียภาษี:0105563047244, Tel:020964499{"\n"}
              Email: pd.marketinginnovate@gmail.com
            </Text>
          </View>
        </View>
        <View style={styles.section}>
          <Text style={styles.subTitle}>ใบเสร็จรับเงิน/ ใบกำกับภาษี</Text>
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
          {/* ฝั่งซ้าย: ที่อยู่จัดส่ง */}
          <View style={styles.addressContainer}>
            <Text style={styles.addressTitle}>ที่อยู่จัดส่ง</Text>
            <Text style={styles.addressText}><Text style={styles.bold}>ชื่อ:</Text> {name}</Text>
            <Text style={styles.addressText}><Text style={styles.bold}>โทรศัพท์:</Text> {phone}</Text>
            <Text style={styles.addressText}><Text style={styles.bold}>อีเมล:</Text> {email}</Text>
            <Text style={styles.addressText}><Text style={styles.bold}>ที่อยู่:</Text> {address}</Text>
            {order.deliveryMethod === "branchPickup" && order.branchName && (
              <Text style={styles.addressText}>
                <Text style={styles.bold}>รับที่สาขา:</Text> {order.branchName}
              </Text>
            )}
          </View>

          {/* ฝั่งขวา: เลขที่ใบกำกับและวันที่ออกใบเสร็จ */}
          <View style={{ alignItems: 'flex-end' }}>
            <Text style={styles.subTitle}>เลขที่ใบกำกับ: {order.orderNumber}</Text>
            <Text style={styles.subTitle}>
              วันที่ออกใบเสร็จ:{" "}
              {new Date(order.createdAt).toLocaleDateString("th-TH", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Text>
          </View>
        </View>

        <View style={styles.section}>
          {/* <Text style={styles.text}>360 HealthyShope</Text>
          <Text>{moment(Date.now()).locale('th').format('LL')}</Text> */}


          {/* <View style={styles.section}>
            <Text style={styles.subTitle}>เลขที่ใบกำกับ: {order.orderNumber}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.subTitle}>วันที่ออกใบเสร็จ:{" "}
              {new Date(order.createdAt).toLocaleDateString("th-TH", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}</Text>
          </View> */}
          {/* <View style={styles.section}>
            <Text style={styles.subTitle}>ใบเสร็จรับเงิน/ ใบกำกับภาษี</Text>
          </View> */}

          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>รายการสินค้า</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>ราคาสินค้า</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>จำนวนสินค้า</Text>
              </View>
            </View>

            {order.products.map((item, index) => (
              <View style={styles.tableRow} key={index}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{item.product.title}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{item.price}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{item.count}</Text>
                </View>
              </View>
            ))}

          </View>
          <View style={{ marginTop: 10 }}>
            <Text style={styles.summary}>
              PRICE EXCLUDE VAT / รวมราคาสินค้า(ไม่รวม VAT):{" "}
              {totalNotVat.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท
            </Text>
            <Text style={styles.summary}>
              VAT TOTAL(7%)/ภาษีมูลค่าเพิ่ม(7%):{" "}
              {totalBeforeDiscount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} บาท
            </Text>
            {order.couponDiscount > 0 && (
              <Text style={styles.summary}>
                {/* คำนวณส่วนลดเป็นจำนวนเงิน */}
                ส่วนลดคูปอง {couponAmount.toFixed(2)} บาท
              </Text>
            )}
            {order.pointsDiscount > 0 && (
              <Text style={styles.summary}>
                ส่วนลดจากแต้ม: -{order.pointsDiscount} บาท
              </Text>
            )}




            {/* <Text style={styles.summary}>
              ({numberToThaiText(
                order.cartTotal -
                (order.cartTotal * order.couponDiscount) / 100 -
                order.pointsDiscount
              )})
            </Text> */}
          </View>
          <Text style={styles.summary}>ราคารวมสุทธิ: {order.cartTotal} บาท</Text>
          <Text style={styles.summary}>({numberToThaiText(order.cartTotal)})</Text>
        </View>

        {/* <View style={styles.signatureContainer}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>
              ได้รับสินค้าตามรายการข้างบนไว้เรียบร้อยแล้ว
            </Text>
            <Text style={styles.receiverText}>ผู้รับสินค้า ......................................................</Text>
            <Text style={styles.receiverText}>วันที่...............................................................</Text>
          </View>

          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>
              ช่องเพิ่มเติมสำหรับข้อมูลอื่นๆ
            </Text>
            <Text style={styles.receiverText}>ผู้ส่งสินค้า ......................................................</Text>
            <Text style={styles.receiverText}>วันที่...............................................................</Text>
          </View>

          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>
              ในนาม บริษัท พีดีมาร์เก็ตติง อินโนเวท จํากัด
            </Text>
            <View style={styles.signatureLine}></View>
            <Text style={styles.signatureText}>ผู้มีอํานาจลงนาม</Text>
          </View>
        </View> */}

        <View style={styles.signatureContainer}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}></Text>
            <Text style={styles.receiverText}>ผู้รับสินค้า ......................................................</Text>
            <Text style={styles.receiverText}>
              วันที่ {new Date(order.createdAt).toLocaleDateString("th-TH", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Text>
          </View>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureText}>
              ในนามบริษัท บริษัท พีดี มาร์เก็ตติ้ง อินโนเวท จำกัด
            </Text>
            <Text style={styles.receiverText}>ผู้ส่งสินค้า ......................................................</Text>
            <Text style={styles.receiverText}>
              วันที่ {new Date(order.createdAt).toLocaleDateString("th-TH", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Text>
          </View>
        </View>
        <View style={styles.bottomRightContainer}>
          <Image style={styles.bottomRightLogo} src={base64Logo} />
          <Text style={styles.bottomRightText}>360° HEALTHY SHOP</Text>
        </View>
      </Page>
    </Document>
  );
};

export default Invoice;
